
import { CommandButton, IButtonProps, IContextualMenuProps, Text } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { Badge } from 'primereact/badge';

export interface CustomCommandButtonProps {
    badge?: any,
    iconPropFontAwesome?: any,
    menuProps?: IContextualMenuProps
}

type Props = CustomCommandButtonProps & RouteComponentProps & IButtonProps

const CustomCommandButton: React.FunctionComponent<Props> = props => {


    const onRenderIcon = (item, defaultRenderer) => {

        let iconSyle = {};
        //faccio il merge degli stili
        item.styles.icon.map(it => iconSyle = { ...iconSyle, ...it })

        if (item.iconPropFontAwesome) {
            // se ho impostato l'icona di fontawsome 
            return (

                <React.Fragment>
                    <FontAwesomeIcon style={iconSyle} {...item.iconPropFontAwesome} /> 
                </React.Fragment>
            );
        }
        else if (item.iconPropIcoMoon) {
            // se ho impostato l'icona di icomoon 
            return (

                <React.Fragment>
                    <span style={iconSyle} {...item.iconPropFontAwesome}></span>

                </React.Fragment>
            );
        }
        else {
            // altrimenti mostro l'icona di fluentui
            return (

                <React.Fragment>
                    {defaultRenderer(item)}
                </React.Fragment>
            );
        }
    }
    const onRenderText = (item, defaultRenderer) => {

        return (

            <React.Fragment>
                {item.badge ?
                    // se ho impostato un badge lo mostro
                    <React.Fragment>
                        <div className="mr-3">
                            <div className="p-overlay-badge">
                                <Text className="px-2">{item.text}</Text>
                                <Badge value={item.badge} className="ml-2"></Badge>
                            </div>
                        </div>

                    </React.Fragment> :
                    // altrimenti il render di default
                    <Text className="px-2">{item.text}</Text>
                }
            </React.Fragment>
        );
    }

    return (
        <CommandButton
            {...props}
            className={props.className ? props.className : ''}
            onRenderText={onRenderText}
            onRenderIcon={onRenderIcon}
            iconProps={props.iconProps}
        />
    );
};


export default withRouter(CustomCommandButton);